<template>
  <div>
    <h3>
      Contacts
      <v-btn :disabled="isLoading"
             @click="showContactAddEditDialog = true"
             class="text-none ml-2"
             color="secondary darken-1"
             fab
             x-small>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </h3>
    <v-card :key="contact.id"
            class="mt-5"
            no-gutters
            v-for="contact in contacts">
      <v-card-text style="white-space: pre-wrap;">
        <strong>
          {{ contact.name + " " + contact.surname }}
          <span v-if="contact.designation">
            - {{ getDesignationDescription(contact.designation) }}
          </span>
        </strong>
        <v-card-text style="white-space: pre-wrap;">
          <v-row>
            Email: {{ contact.email }}
          </v-row>
          <v-row class="mt-5">
            Number: {{ contact.number }}
          </v-row>

        </v-card-text>
      </v-card-text>

      <v-card-actions>
        <v-btn :disabled="isLoading || contactDeleting"
               :loading="contactDeleting"
               class="text-none"
               color="secondary darken-1"
               text
               @click="deleteContact(contact)">
          Delete
        </v-btn>
        <v-spacer/>
        <v-btn class="text-none"
               color="secondary darken-1"
               text
               @click="editContact(contact)">
          Edit
        </v-btn>
      </v-card-actions>


    </v-card>
    <company-contact-add-edit-dialog :company-id="companyId"
                                     :show="showContactAddEditDialog"
                                     :company-contact-designations="companyContactDesignations"
                                     :contact="contactToEdit"
                                     @contact-added="contactAdded"
                                     @contact-updated="contactUpdated"
                                     @close="showContactAddEditDialog=false"/>
  </div>
</template>

<script>
import CompanyContactAddEditDialog from "@/components/widgets/CompanyContacts/CompanyContactAddEditDialog.vue";

export default {
  name: "CompanyContactsList",
  components: {
    CompanyContactAddEditDialog
  },
  props: ['companyId', 'contacts', 'companyContactDesignations'],
  data() {
    return {
      isLoading: false,
      contactDeleting: false,
      showContactAddEditDialog: false,
      contactToEdit: null,
    }
  },
  methods: {
    contactAdded(contact) {
      this.$emit("contact-added", contact);
    },
    editContact(contact) {
      this.contactToEdit = contact;
      this.showContactAddEditDialog = true;
    },
    contactUpdated(contact){
      this.$emit('contact-edited', contact);
    },
    deleteContact(contact){
      const isConfirmed = confirm(
          "Are you sure you want to delete this contact?"
      );
      if (isConfirmed) {
        this.isLoading = true;
        this.isDeleting = true;
        this.$store
            .dispatch("companies/deletecontact", {companyid: this.companyId, customercompanycontactid: contact.id})
            .then(
                () => {
                 this.$emit('contact-deleted', contact.id)
                },
                error => this.$emit("on-error",error.response.data)
            );
      }
      this.isLoading = false;
    },
    getDesignationDescription(key) {
      let designation = this.companyContactDesignations.find(d => d.key === key);
      if (designation) {
        return designation.value;
      }
      return '';
    }
  },
}
</script>

<style scoped>

</style>
